import get from 'lodash/get';

import { apiGet, apiPatch, buildApiURL } from '@src/services/api';

const getCurrentUser = () => {
    return apiGet(buildApiURL('/api/v1/user'));
};

const patchTogglePremierUserBanner = (data) => {
    return apiPatch(
        buildApiURL(`/api/v1/users/${data.uuid}/toggle_premier_banner`),
        {},
    ).then((response) => get(response, ['data', 'user']));
};

export { getCurrentUser, patchTogglePremierUserBanner };
